import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import TabNavigation from 'components/tab/TabNavigation/TabNavigation';

import TabCarouselContent from './components/TabCarouselContent/TabCarouselContent';

const flatMapContentToArrays = content => content.reduce(
  ({ labelsArray, componentsArray }, contentItem) => ({
    labelsArray: [...labelsArray, contentItem.tabLabel],
    componentsArray: [...componentsArray, contentItem.component],
  }),
  { labelsArray: [], componentsArray: [] },
);

class StaticTabContent extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      selectedTabIndex: 0,
    };
  }

  updateTabIndex = selectedTabIndex => {
    this.setState({ selectedTabIndex });
  };

  render() {
    const { content } = this.props;
    const { selectedTabIndex } = this.state;

    const { labelsArray, componentsArray } = flatMapContentToArrays(content);

    return (
      <>
        <TabNavigation
          labelsArray={labelsArray}
          selectedTabIndex={selectedTabIndex}
          updateTabIndex={this.updateTabIndex}
        />
        <TabCarouselContent
          componentsArray={componentsArray}
          selectedTabIndex={selectedTabIndex}
          updateTabIndex={this.updateTabIndex}
        />
      </>
    );
  }
}

StaticTabContent.propTypes = {
  content: PropTypes.arrayOf(
    PropTypes.shape({
      component: PropTypes.node.isRequired,
      tabLabel: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default StaticTabContent;
